import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';

import { LastSaved } from '@/components/form-elements/LastSaved';
import { SidebarLayout } from '@/components/layouts/SidebarLayout';
import { useAppAbility } from '@/hooks/useAppAbility';
import { useCurrentTab } from '@/hooks/useCurrentTab';
import { IndicatorRoutingScheduleForm } from '@/indicator-process/configuration/IndicatorRoutingScheduleForm';
import { IndicatorRoutingStatusForm } from '@/indicator-process/configuration/IndicatorRoutingStatusForm';
import { Action, Subject } from '@/services/api';

const navigationItems = ['Status', 'Zeitplan'];

export function IndicatorRoutingConfigurationPage() {
  const { currentTab } = useCurrentTab();
  const ability = useAppAbility();

  const [lastSaved, setLastSaved] = useState<Dayjs>();

  return (
    <SidebarLayout
      type="tabs"
      navigationItems={navigationItems}
      buttonLabel={
        currentTab === 1 && ability.can(Action.UPDATE, Subject.INDICATOR_ROUTING_CONFIGURATION)
          ? 'Speichern'
          : undefined
      }
      actionArea={currentTab === 1 && <LastSaved lastSaved={lastSaved} />}
    >
      {(tab: number) => (
        <>
          {tab === 0 && <IndicatorRoutingStatusForm />}
          {tab === 1 && (
            <IndicatorRoutingScheduleForm
              onMutate={() => setLastSaved(undefined)}
              onSuccess={() => setLastSaved(dayjs())}
            />
          )}
        </>
      )}
    </SidebarLayout>
  );
}
